const {PurchaseOrderItem} = require( './PurchaseOrderItem')
const {JustDate} = require('./JustDate')
const {AddressModel} = require( './AddressModel')

/**
 * This is the model for PurchaseOrder
 */
class PurchaseOrder {
    /**
     * This is a default constructor for PurchaseOrder
     * @param {Number} id
     * @param {JustDate} orderDate
     * @param {JustDate} deliveryDate
     * @param {string} vendorName
     * @param {JustDate} expectedOrderDate
     * @param {string} shipVia
     * @param {string} orderBy
     * @param {JustDate} expectedDeliveryDate
     * @param {Number} subTotal
     * @param {Number} salesTax
     * @param {Number} shippingCharge
     * @param {Number} discount
     * @param {AddressModel} asanteShippingAddress
     * @param {AddressModel} vendorShippingAddress
     * @param {String} notes
     * @param {String} terms
     * @param {[PurchaseOrderItem]} items
     */
    constructor(
        id='',
        orderDate=null,
        deliveryDate=null,
        vendorName='',
        expectedOrderDate=new JustDate(),
        shipVia='',
        orderBy='',
        expectedDeliveryDate=new JustDate(),
        subTotal=0.0,
        salesTax=0.0,
        shippingCharge=0.0,
        discount=0.0,
        asanteShippingAddress=new AddressModel(),
        vendorShippingAddress=new AddressModel(),
        notes='',
        terms='',
        items=[new PurchaseOrderItem()],
    ) {
        this.id = id
        this.order_date = orderDate
        this.delivery_date = deliveryDate
        this.vendor_name = vendorName
        this.expected_order_date = expectedOrderDate
        this.ship_via = shipVia
        this.order_by = orderBy
        this.expected_delivery_date = expectedDeliveryDate
        this.sub_total = subTotal
        this.sales_tax = salesTax
        this.shipping_charge = shippingCharge
        this.discount = discount
        this.asante_shipping_address = asanteShippingAddress
        this.vendor_shipping_address = vendorShippingAddress
        this.notes = notes
        this.terms = terms
        this.items = items
    }

    /**
     * Create a new PurchaseOrder from json
     * @param {json} json
     * @return {PurchaseOrder}
     */
    static from(json) {
        const po = Object.assign(new PurchaseOrder(), json)

        if (po.order_date) {
            po.order_date = JustDate.from(po.order_date)
        }
        if (po.delivery_date) {
            po.delivery_date = JustDate.from(po.delivery_date)
        }
        po.expected_order_date = JustDate.from(po.expected_order_date)
        po.expected_delivery_date = JustDate.from(po.expected_delivery_date)

        po.asante_shipping_address =
            AddressModel.from(po.asante_shipping_address)
        po.vendor_shipping_address =
            AddressModel.from(po.vendor_shipping_address)

        for (let i = 0; i < po.items.length; i++) {
            po.items[i] = PurchaseOrderItem.from(po.items[i])
        }

        return po
    }

    /**
     * Copies PurchaseOrderItem object
     * @return {PurchaseOrderItem}
     */
    copy() {
        return PurchaseOrderItem.from(this)
    }

    /**
     * Calculates the sub total price
     * @return {Number}
     */
    sub_total() {
        return this.items.sum((item) => item.total())
    }

    /**
     * Calculates the total price
     * @return {Number}
     */
    total() {
        return this.sub_total +
            Number.parseFloat(this.sales_tax) +
            Number.parseFloat(this.shipping_charges) -
            Number.parseFloat(this.discount)
    }
}

module.exports = {
    PurchaseOrder,
}

